import { DateTime } from '@ksyos/date-time';

type DateTimeLike = DateTime | Date | string | number;

interface IDateObject {
    endDate?: DateTimeLike | null;
    startDate: DateTimeLike | null;
}

export function isActiveOnDate<T extends IDateObject>(item: T, date: DateTimeLike) {
    if (!item.startDate) {
        return false;
    }
    const dateTime = DateTime.from(date);

    return dateTime.isBetween(item.startDate, item.endDate || '9999-12-31', 'day', '[]');
}

export function isActiveInTheFuture<T extends IDateObject>(item: T, date: DateTimeLike) {
    if (!item.startDate) {
        return false;
    }
    const dateTime = DateTime.from(date);

    return dateTime.isSameOrBefore(DateTime.from(item.startDate), 'day');
}

export function isActiveOnDateOrInTheFuture<T extends IDateObject>(item: T, date: DateTimeLike) {
    if (!item.startDate) {
        return false;
    }

    return isActiveOnDate(item, date) || isActiveInTheFuture(item, date);
}
